import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step?.description;

export const getDescription = ({ step, t }) => {
  // currently there is only a loop type of 'for_each_item'
  return t("For each item in '{{ variable }}'", {
    variable: step?.details?.forEachItem?.arrayVariable?.label,
  });
};

export default function LoopCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
